import { noop } from "nodash"
import { createContext, FC, useContext } from "react"

export const LeftPanelContext = createContext<{
    register: (config: LeftPanelConfig) => void
    unregister: (key: string) => void
}>({ register: noop, unregister: noop })

export const useLeftPanelRegistry = () => {
    return useContext(LeftPanelContext)
}

export interface LeftPanelConfig {
    Item: FC
    key: string
    cleanup?: () => void
    options?: { resizable?: boolean }
}
